module.exports = __webpack_public_path__ + "static/media/no-notifications.0721982d.svg";